// module.exports = Templok;
export class GameConstants {

    public static readonly VERSION = "0.0";
    public static readonly DEVELOPMENT = false;
    public static readonly DEBUG_MODE = false;
    public static readonly VERBOSE = false;
    public static readonly SUPPORTS_REWARDED_ADS = true;
    public static readonly GAME_WIDTH = 768;
    public static readonly GAME_HEIGHT = 1024;
    public static readonly BLOCKS_NUM_COLOURS = 6;
    public static readonly SAVED_GAME_DATA_KEY = "templok-data";
}
